import React from 'react'
import {Box, Flex, Link} from '@primer/components'

export default function Bar() {
  return (
    <Flex bg="gray.9" px={3} css={{height:40}} style={{minWidth:0}} alignItems="center">
      <Box py={6} maxWidth="1280px" width="100%" mx={"auto"}>
        <Flex.Item pb={1}>
          <Link fontSize={0} lineHeight={1} color="white" href="https://github.com">
          Back to GitHub.com
          </Link>
        </Flex.Item>
      </Box>
    </Flex>
  )
}